(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["am-b2b-form-fallback"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('am-b2b-form-fallback')) {
    class AmB2bFormFallback extends HTMLElement {
      connectedCallback() {
        const primaryFormRoot = document.querySelector('[data-form-root]');
        if (!primaryFormRoot) return;

        const syncVisibility = () => {
          const appFormLoaded = primaryFormRoot.childElementCount > 0 || Boolean(primaryFormRoot.shadowRoot);
          this.hidden = appFormLoaded;
        };

        syncVisibility();
        new MutationObserver(syncVisibility).observe(primaryFormRoot, { childList: true, subtree: true });
      }
    }

    customElements.define('am-b2b-form-fallback', AmB2bFormFallback);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
